/* Via dei Mille — le entrate.

   Accende una volta sola quello che entra nell'inquadratura. Tutto il resto —
   quanto dura, di quanto si alza, cosa fa una fotografia invece di una
   piastrella — sta in vdm-base.css: qui non c'e' nessun numero di stile.

   Contratto col documento:

     .vdm-rivela              entra quando lo si vede
     [data-vdm-passo="70"]    su un antenato: il ritmo della fila, in ms
     .e-vista                 la mette questo file quando e' il momento

   **La scala si conta su chi entra adesso, non su chi sta nel contenitore.**
   Nella prima stesura si osservava la griglia intera e si sfalsavano i suoi
   figli tutti insieme: bastava che il bordo alto della griglia si affacciasse
   e partivano tutte e sette le piastrelle, comprese le tre che erano ancora
   mille pixel piu' giu'. Quando ci si arrivava scorrendo erano finite da un
   pezzo, e l'effetto era che non ci fosse nessun effetto. Ora ogni piastrella
   ha il suo osservatore, e il ritardo si assegna dentro il gruppo di quelle
   che si affacciano nello stesso battito: una fila che arriva insieme si
   sfalsa, una che arriva da sola non aspetta nessuno.

   Tre cose che non fa, e sono tutte volute:

   - non toglie mai `e-vista`. Una cosa entra una volta sola; tornando indietro
     con lo scorrimento la pagina sta ferma, perche' una pagina che rifa'
     l'ingresso a ogni passaggio e' una giostra, non un negozio.
   - non ascolta lo scorrimento. Un IntersectionObserver non gira a ogni
     fotogramma e non forza il ricalcolo dell'impaginazione; un listener su
     `scroll` fa tutte e due le cose.
   - non fa niente a movimento ridotto. Non una versione breve: niente. Il
     foglio di stile in quel caso non nasconde nulla, quindi non c'e' nemmeno
     niente da riaccendere.
*/

(function () {
  const FERMO = matchMedia('(prefers-reduced-motion: reduce)');
  if (FERMO.matches || !('IntersectionObserver' in window)) return;

  const PASSO_PREDEFINITO = 90;
  // Oltre il quarto la scala smette di crescere: piu' in la' il ritardo
  // diventerebbe un'attesa, e un'attesa non e' piu' un'entrata.
  const PASSI_MAX = 4;

  function passo(nodo) {
    const gruppo = nodo.closest('[data-vdm-passo]');
    return (gruppo && Number(gruppo.dataset.vdmPasso)) || PASSO_PREDEFINITO;
  }

  // Il margine negativo in basso fa scattare l'entrata quando l'elemento e'
  // dentro per davvero e non quando sfiora il bordo: cosi' il movimento si
  // vede finito, invece di cominciare fuori campo e arrivare gia' concluso.
  const osservatore = new IntersectionObserver(
    (voci) => {
      const entrate = voci.filter((v) => v.isIntersecting);
      if (!entrate.length) return;
      // In ordine di lettura, non in ordine di notifica: l'osservatore le
      // consegna nell'ordine in cui sono state registrate, che su una griglia
      // a ritmo variabile non e' quello in cui si vedono.
      entrate.sort((a, b) =>
        a.boundingClientRect.top - b.boundingClientRect.top ||
        a.boundingClientRect.left - b.boundingClientRect.left
      );
      entrate.forEach((voce, i) => {
        osservatore.unobserve(voce.target);
        voce.target.style.setProperty(
          '--vdm-ritardo',
          Math.min(i, PASSI_MAX) * passo(voce.target) + 'ms'
        );
        voce.target.classList.add('e-vista');
      });
    },
    { rootMargin: '0px 0px -5% 0px', threshold: 0 }
  );

  // Da qui in poi comanda l'osservatore: la classe allunga il salvagente del
  // foglio di stile da 2,5 a 7 secondi. Si mette adesso e non in cima al file,
  // perche' sopra ci sono ancora due strade che escono senza osservare niente,
  // e allungare il salvagente senza poi accendere nulla farebbe aspettare la
  // pagina per sette secondi invece di due e mezzo.
  document.documentElement.classList.add('e-movimento');

  document.querySelectorAll('.vdm-rivela').forEach((n) => osservatore.observe(n));
})();
